import { getNationalIpCheck } from '@encarpkg/api';

export const checkKoreanIp = async () => {
	try {
		const { data } = await getNationalIpCheck();
		return data.isKoreanIp;
	} catch (e) {
		console.error(e);
		return true;
	}
};

export default null;
